import installationInstructions from './installationInstructions';

const loocContent = {
  installationInstructions
}

export { loocContent };
